import { render, staticRenderFns } from "./LayoutLoading.vue?vue&type=template&id=2d136a52&scoped=true"
import script from "./LayoutLoading.vue?vue&type=script&lang=js"
export * from "./LayoutLoading.vue?vue&type=script&lang=js"
import style0 from "./LayoutLoading.vue?vue&type=style&index=0&id=2d136a52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d136a52",
  null
  
)

export default component.exports